import React from 'react';
import { TimePickerTemplate } from 'themes/components';

class TimePicker extends React.Component {
	render() {
		return <TimePickerTemplate {...this.props} />;
	}
}

export default TimePicker;
